let ClientQuicksightURL = () => {
  let client = localStorage.getItem('customerNo');

  switch (client) {
    case "1371":
      return {
        "VEHICLE_DOCUMENT_REPORT": '22785a3b-56a0-4ebc-913b-328e94bd5091',
        "CURRENT_MONTH_JOBCARD_ANALYSIS": 'f3a871ad-7cab-4265-b1fb-92471aa9a5e3',
        "TRANSACTION_HISTORY_REPORT": '27a2ff42-630d-4ffd-b82b-d97e89d82945',
        "CURRENT_TYRE_RUN_REPORT": 'ae474796-49bf-481c-bc69-74809fa10aaa',
        "HISTORIC_TYRE_RUN_REPORT": '084dad82-1c09-4277-85ba-89b3ec705e7c',
        "HISTORIC_BATTERY_REPORT": 'f1956301-d83e-4f75-ad87-2ac69603072d'

      }
    case "503":
      return {
        "VEHICLE_DOCUMENT_REPORT": 'a2e7842c-ea13-4f4f-9888-31934f5b91a3',
        "CURRENT_MONTH_JOBCARD_ANALYSIS": '8e14c5df-20f7-477a-b4a8-c28085540e63',
        "TRANSACTION_HISTORY_REPORT": '09a98ba7-7a77-4816-973a-9c3b751da306',
        "CURRENT_TYRE_RUN_REPORT": 'ce791165-92b2-4e98-9a50-0ff02ddd6f33',
        "HISTORIC_TYRE_RUN_REPORT": '377342c3-c974-4a54-8ba2-99a625eca2ca',
        "HISTORIC_BATTERY_REPORT": 'f6d14d3c-9a38-4d1e-84ac-bccb45bea8d7'
      }
    default: //1158 Client
      return {
      }
  }
}

export default ClientQuicksightURL();